import { styled, ToggleButtonGroup } from "@mui/material";

export const TpToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  '& .MuiToggleButton-root': {
    height: '24px',
    paddingTop: 0,
    paddingBottom: 0,
    whiteSpace: 'nowrap',
    fontSize: '0.8125rem',
    textTransform: 'none',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid',
    borderColor: theme.palette.divider,
    borderRadius: 0,

    '&:hover': {
      backgroundColor: theme.palette.primary[400],
      color: theme.palette.primary.contrastText,
    },

    '&:first-of-type': {
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
    },

    '&:last-of-type': {
      borderTopRightRadius: 8,
      borderBottomRightRadius: 8,
    },

    '&:not(:last-of-type)': {
      borderRight: '1px solid',
      borderColor: theme.palette.divider,
      marginRight: '1px',
    },

    '&:not(:first-of-type)': {
      borderLeft: '1px solid',
      borderColor: theme.palette.divider,
      marginLeft: '-1px',
    },

    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      borderColor: theme.palette.primary.main,

      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  },
}))
